import { Adapter, SendToOptions } from './adapter';
import { getScript } from '../utils/http';

// TODO: test
export default class AdapterImpl implements Adapter {
  public async init(): Promise<void> {
    if (typeof window.TGMobileShare !== 'function') {
      await getScript('https://ossweb-img.qq.com/images/js/TGMobileShare/TGMobileShare.min.js');
    }
  }
  public async sendTo(config: any, shareConfig: SendToOptions): Promise<void> {
    const { title, desc, url, imgUrl, actName } = shareConfig;
    window.TGMobileShare({
      shareTitle: title, // 不设置或设置为空时，页面有title，则调取title
      shareDesc: desc, // 不设置或设置为空时，页面有Description，则调取Description
      shareImgUrl: imgUrl, // 分享图片尺寸200*200，且填写绝对路径
      shareLink: url, // 分享链接要跟当前页面同域名(手Q分享有这个要求) ,不设置或设置为空时，默认调取当前URL
      actName, // 点击流命名，用于统计分享量，专题一般采用目录名称如a20151029demo
      onShare: {
        WXToMessageSuccess: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxf', true);
          }
        },
        WXToMessageCancel: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxf', false);
          }
        },
        WXToTimelineSuccess: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxt', true);
          }
        },
        WXToTimelineCancel: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxt', false);
          }
        },
        QQToQQSuccess: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('qqf', true);
          }
        },
        QQToQQCancel: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('qqf', false);
          }
        },
        QQToQzoneSuccess: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('qqz', true);
          }
        },
        QQToQzoneCancel: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('qqz', false);
          }
        },
        QQToMessageSuccess: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxf', true);
          }
        },
        QQToMessageCancel: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxf', false);
          }
        },
        QQToTimelineSuccess: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxt', true);
          }
        },
        QQToTimelineCancel: () => {
          if (typeof config.afterShare === 'function') {
            config.afterShare('wxt', false);
          }
        },
      },
    });
  }
};
